<template>
	<div>
		<table class="ts-w-full">
			<thead>
				<tr>
					<th v-for="col in columns" :key="col.key" :class="col.className"
						v-show="isShow(col.key) >= 0"
						class="ts-py-2 ts-px-2 ts-bg-gray-200">{{
						col.label }}
					</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="!dataPresent">
					<tr>
						<td :colspan="columns.length">
							<div class="ts-w-full ts-h-48 ts-flex ts-items-center ts-justify-center">
								<div class="ts-text-center">
									<i class="far fa-folder-open fa-3x ts-text-gray-300"></i>
									<p class="ts-text-lg ts-font-bold ts-text-gray-300">{{ $t('dailyCloseout.noData') }}</p>
								</div>
							</div>
						</td>
					</tr>
				</template>

				<template v-if="isArray">
					<tr v-for="(row, rIx) in data" :class="{
						'ts-bg-gray-100': rIx % 2 == 1,
						'ts-bg-blue-200': rIx === clickIndex,
						'hover:ts-bg-blue-100': rIx !== clickIndex
					}" class="ts-duration-200 ts-cursor-pointer" @click="rowClick(rIx)">
						<td v-for="col in columns" :key="col.key" :class="col.className" class="ts-py-2 ts-px-2"
							v-show="isShow(col.key) >= 0"
						>
							<div v-if="!col.slot">
								{{ row[col.key] }}
							</div>
							<template v-else>
								<slot :name="col.slot" :row="row" :col="col"></slot>
							</template>
						</td>
					</tr>
				</template>
				<template v-if="isObject">
					<template v-for="(grow, group) in data">
						<tr>
							<td :colspan="columns.length" class="ts-py-2 ts-px-2 ts-bg-gray-200 ts-font-semibold ts-text-gray-800">{{  group }}</td>
						</tr>
						<tr v-for="(row, rIx) in grow" :class="{
							'ts-bg-gray-100': rIx + group % 2 == 1,
							'ts-bg-blue-200': rIx + group === clickIndex,
							'hover:ts-bg-blue-100': rIx + group !== clickIndex
						}" class="ts-duration-200 ts-cursor-pointer" @click="rowClick(rIx + group)">
							<td v-for="col in columns" :key="col.key" :class="col.className" class="ts-py-2 ts-px-2"
							v-show="isShow(col.key) >= 0"
							>
								<div v-if="!col.slot">
									{{ row[col.key] }}
								</div>
								<template v-else>
									<slot :name="col.slot" :row="row" :col="col"></slot>
								</template>
							</td>
						</tr>
					</template>

				</template>
			</tbody>
			<tfoot>
				<slot name="footer"></slot>
			</tfoot>
		</table>
	</div>
</template>
<script>
import { columns } from '../config';


export default {
	name: 'tableList',
	props: {
		columns: {
			type: Array,
			default: () => []
		},		
		visible: {
			type: Array,
			default: () => []
		},
		data: {
			type: Array|Object,
			default: () => []
		}
	},
	computed: {
		isArray() {
			return Array.isArray(this.data)
		},
		isObject() {
			return !Array.isArray(this.data)
		},
		dataPresent() {
			return Object.keys(this.data).length
		},
		isShow: vm => key => {
			return vm.visible.findIndex(el => el === key)
		}
	},
	data() {
		return {
			clickIndex: undefined
		}
	},
	methods: {
		rowClick(idx) {
			this.clickIndex = idx
		}
	}
}
</script>